export default __webpack_public_path__ + "static/media/Blooded Gloves of the Ancestors.0cbb00c5.jpg";